import { firebaseConfig } from '../utils/defaults/defaultValues';

let firebasePromise = null;

export const loadFirebase = () => {
  if (!firebasePromise) {
    firebasePromise = Promise.all([
      import(/* webpackChunkName: "firebase" */ 'firebase/app'),
      import(/* webpackChunkName: "firebase" */ 'firebase/auth'),
      import(/* webpackChunkName: "firebase" */ 'firebase/database'),
      import(/* webpackChunkName: "firebase" */ 'firebase/storage'),
    ]).then(([firebaseModule]) => {
      const firebase = firebaseModule.default;
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }
      return {
        firebase,
        auth: firebase.auth(),
        database: firebase.database(),
        storage: firebase.storage(),
      };
    });
  }
  return firebasePromise;
};

export const getAuth = () => loadFirebase().then((modules) => modules.auth);
export const getFirebase = () => loadFirebase().then((modules) => modules.firebase);
export const getDatabase = () => loadFirebase().then((modules) => modules.database);
export const getStorage = () => loadFirebase().then((modules) => modules.storage);
